module.exports = __webpack_public_path__ + "static/img/hzqy.ba76b6b9.png";